import { useLanguage } from '../contexts/LanguageContext';

/**
 * Period selector pill row with a humanised label.
 *
 * Props:
 *   - value: current period in days (7 | 30 | 90 | 365)
 *   - onChange: setter, called with new day count
 *   - testid: prefix for data-testid attributes (default "period")
 *   - className: optional extra wrapper classes
 *   - options: optional override of the 4 default options
 */
export function PeriodPicker({ value, onChange, testid = 'period', className = '', options }) {
    const { language } = useLanguage();

    const defaults = [
        { v: 7, l: '7T' },
        { v: 30, l: '30T' },
        { v: 90, l: '90T' },
        { v: 365, l: '1J' },
    ];
    const opts = options || defaults;

    const labels = language === 'de'
        ? { 7: 'Letzte 7 Tage', 14: 'Letzte 14 Tage', 30: 'Letzte 30 Tage', 90: 'Letzte 90 Tage', 365: 'Letztes Jahr' }
        : { 7: 'Last 7 days', 14: 'Last 14 days', 30: 'Last 30 days', 90: 'Last 90 days', 365: 'Last year' };
    const periodLabel = labels[value] || `${value} ${language === 'de' ? 'Tage' : 'days'}`;

    return (
        <div className={`flex items-center justify-between ${className}`}>
            <p className="text-xs text-muted-foreground" data-testid={`${testid}-label`}>
                {periodLabel}
            </p>
            <div className="flex gap-1" data-testid={`${testid}-picker`}>
                {opts.map(opt => (
                    <button
                        key={opt.v}
                        type="button"
                        onClick={() => onChange(opt.v)}
                        data-testid={`${testid}-${opt.v}`}
                        className={`text-[11px] px-2.5 py-1 rounded-full font-medium transition-colors ${
                            value === opt.v
                                ? 'bg-primary text-primary-foreground'
                                : 'bg-muted text-muted-foreground hover:bg-muted/80'
                        }`}
                    >
                        {opt.l}
                    </button>
                ))}
            </div>
        </div>
    );
}
